import React from 'react';
import _ from 'lodash';
import PIVIcon from 'go/images/PIV_Icon.jpg';
import {Button, Grid, Header, Image, Segment} from 'semantic-ui-react';
import {ENDPOINT_KEYCLOAK} from 'common/endpoints';
import {ENDPOINT_AUTH} from 'common/endpoints';

export default class PIVLogin extends React.Component {
  handleClick = () => {
    const baseUri = window.location.origin;
    window.location.href = `${ENDPOINT_KEYCLOAK}?kc_idp_hint=DHSAuthPortal&client_id=femago&response_type=code&redirect_uri=${baseUri}${ENDPOINT_AUTH}`;
  };
  render() {
    let headerText = 'FEMA employees';
    let buttonText = 'Log in with your PIV card';
    if (_.get(this.props, 'loginGovIntegration', false)) {
      headerText += ' and partners';
      buttonText = 'Sign in with your PIV card';
    }
    return (
      <Segment>
        <Header as="h3" dividing color="blue">
          {headerText}
        </Header>
        <Grid>
          <Grid.Column width="6">
            <Image alt="PIV card" src={PIVIcon} />
          </Grid.Column>
          <Grid.Column width="10">
            <p>Insert your PIV card into your smart card reader</p>
            <Button primary compact onClick={this.handleClick}>
              {buttonText}
            </Button>
          </Grid.Column>
        </Grid>
      </Segment>
    );
  }
}
